// @flow strict
import React from 'react'
import cx from 'classnames'

import styles from './PaidSubtitleSection.module.scss'
import { MarkdownContent } from '../MarkdownContent'

type SubtitleSectionProps = {
  subtitle: string,
  blurb?: string,
  leftAlign?: boolean,
}

const PaidSubtitleSection = ({
  subtitle,
  blurb,
  leftAlign,
}: SubtitleSectionProps) => (
  <div className={cx(styles.container, styles.centerAlign)}>
    <h2 className={styles.subtitle}>{subtitle}</h2>
    <div className={styles.description}>
      {blurb && <MarkdownContent>{blurb}</MarkdownContent>}
    </div>
  </div>
)

export default PaidSubtitleSection
